module.exports = __webpack_public_path__ + "img/index01.3a5c7ad0.svg";